import { Component, ChangeDetectionStrategy } from '@angular/core';
import { PaymentsGridComponent } from './components/payments-grid/payments-grid.component';

@Component({
  selector: 'app-vipps-payments',
  imports: [PaymentsGridComponent],
  templateUrl: './vipps-payments.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: '../../styles/page.scss',
})
export class VippsPaymentsComponent {}
